module.exports = __webpack_public_path__ + "img/logo-general-center-text.747f2d69.svg";